import React from 'react';
import { Badge, Card } from '@printdeal/ui-library';
import { Link as GatsbyLink } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import { getConfiguration } from '../../../helpers/Configuration';
import ContentfulCardImage from '../../ContentfulCardImage';
import { type ProductListCardProps } from './types';

const { channel: { brand } } = getConfiguration();

const ProductListCard = ({
  product,
  imagePriority,
  cardVariant,
}: ProductListCardProps) => {
  const img = brand === 'impressto' ? product?.galleryImage : product?.featuredImage;
  return (
    <Card
      image={img && (
        <ContentfulCardImage
          src={img?.url ?? ''}
          priority={imagePriority}
          alt={img.title}
        />
      )}
      title={product.name ?? ''}
      link={<GatsbyLink to={product?.path!} />}
      className="pd-h-full"
      variant={cardVariant}
      badge={product?.productDiscounts?.length ? (
        <Badge variant="warning">
          <FormattedMessage
            id="product.discount"
            defaultMessage="{percentage} % discount"
            values={{ percentage: product.productDiscounts[0].discountValue.percentage }}
          />
        </Badge>
      ) : undefined}
    />
  );
};

export default ProductListCard;
